export const GET_RECORDS = 'providers/Records/GET_RECORDS';
export const GET_HEADERS = 'providers/Records/GET_HEADERS';
export const GET_SECRET = 'providers/Records/GET_SECRET';
export const GET_CLIENT_ID = 'providers/Records/GET_CLIENT_ID';
export const CREATE_RECORD = 'providers/Records/CREATE_RECORD';
export const EDIT_RECORD = 'providers/Records/EDIT_RECORD';
export const DELETE_RECORD = 'providers/Records/DELETE_RECORD';
